/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const YouTubeBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="m8.34 18.742 4.103.075c.007 0 .02 0 .02.01 2.285.042 4.51-.092 6.79-.258 1.818-.127 2.249-1.447 2.474-3.02.28-1.9.343-3.822.196-5.735l-.02-.274c-.138-1.83-.292-3.887-2.455-4.267a9.599 9.599 0 0 0-1.397-.166c-4.42-.143-8.879-.18-13.308.127-1.313.085-2.161.862-2.377 2.164a28.44 28.44 0 0 0-.258 7.045l.008.086c.145 1.646.314 3.57 2.261 3.968 1.048.218 2.116.227 3.185.235.26.002.519.005.778.01Zm3.82-5.132c-.706.407-1.415.814-2.13 1.224V8.965l2.353 1.351 2.756 1.584-2.978 1.71Z" /></svg>);
const YouTube = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={YouTubeBase} {...rest} ref={ref} />);
export default YouTube;